export default __webpack_public_path__ + "static/media/star.d19de7e3.jpeg";